<div #scrollContainer class="relative overflow-x-auto shadow-md sm:rounded-lg max-h-screen-200 overflow-y-auto">
  <table class="w-full text-sm text-left rtl:text-right text-gray-500">
    <thead class="text-xs uppercase bg-amazone-orange text-gray-100 sticky top-0 z-10">
      <tr>
        <th scope="col" class="px-6 py-3">
          <app-header-sorter
            [headerTitle]="'Sw Part Numbers'"
            [field]="getPropertyName('number')"
            [arrow]="sortingConfiguration.getArrowDirection(getPropertyName('number'))"
            (clicked)="sortBy($event)"
          ></app-header-sorter>
        </th>
      </tr>
    </thead>
    <tbody>
      @for (swPartNumber of recycledSwPartNumbers; track $index) {
        <tr class="odd:bg-white even:bg-gray-50 border-b border-gray-200 hover:bg-gray-100 hover:text-amazone-orange">
          <th scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap cursor-pointer">
            {{ swPartNumber.number ?? 'N/A' }}
          </th>
        </tr>
      } @empty {
        <tr>
          <td colspan="1" class="px-6 py-4 text-center text-gray-500">No deactivated sw part numbers found.</td>
        </tr>
      }
    </tbody>
  </table>
</div>
